
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Nashiktomumbaicab() {



    const cardData =
    {
        keyword: ' Nashik to Mumbai Cab   ',
        heading: 'Deva Cabs: Nashik to Mumbai Cab   ',
        headingDescription: 'Deva Cabs offers reliable and comfortable cab services from Nashik to Mumbai, perfect for business travel, weekend trips, and family journeys. Covering a distance of approximately 170 km, our well-maintained vehicles—including Sedans, SUVs, and Innova Crysta—ensure a smooth and enjoyable ride along scenic highways. With professional chauffeurs, fixed-fare packages, and door-to-door pickup, you get flexibility and ease. Available 24/7 with transparent pricing and attentive customer care, Deva Cabs makes your Nashik to Mumbai cab travel seamless, safe, and stress-free.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Marine Drive",
    "location": "South Mumbai, Maharashtra",
    "description": "Known as the ‘Queen’s Necklace’, this 3.6 km C-shaped promenade along the Arabian Sea is lined with art-deco buildings and palm trees. Perfect for sunset strolls or evening breezes, it lights up like a string of pearls at night. Whether it’s a quiet morning jog or enjoying street-side chai, Marine Drive encapsulates Mumbai’s coastal charm and historical elegance."
  },
  {
    "title": "Gateway of India",
    "location": "Colaba, South Mumbai, Maharashtra",
    "description": "Erected in 1924 to commemorate the visit of King George V and Queen Mary, this majestic basalt arch stands majestically by the sea, with the iconic Taj Mahal Palace Hotel beside it. A starting point for ferry trips to Elephanta Caves, it buzzes with street performers, photographers, and tourists soaking in its colonial history."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage site reachable by an hour-long ferry ride from the Gateway. These rock-cut caves dating from the 5th–8th centuries feature grand sculptures, including the iconic Trimurti of Shiva. The island’s lush hillscape and views of the bay create a serene journey back in time."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "location": "Mumbai, Maharashtra",
    "description": "This UNESCO-listed masterpiece from 1887 fuses Victorian Gothic with Indian architectural elements. A living monument, CSMT is one of India’s busiest railway stations, featuring stunning stonework, arched windows, turrets, and intricate carvings that echo Mumbai’s colonial past."
  },
  {
    "title": "Juhu Beach",
    "location": "Juhu, Mumbai, Maharashtra",
    "description": "A bustling sandy stretch known for its vibrant street-snack culture—vada pav, bhel puri, pav bhaji—sunset seekers, and Bollywood celebrity neighborhood. Joggers, kite-flyers, and families mingle here as foamy waves lap the shore, making it a quintessential slice of Mumbai life."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "Renowned for its black stone idol of Lord Ganesha with a trunk curving to the right, this temple sees millions of devotees, especially on Tuesdays. The atmosphere is charged with faith, and the temple’s ornate gold-plated sanctum adds to its spiritual grandeur."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "A white-domed Sufi shrine built on a sea-locked islet and accessible via a narrow causeway at low tide. Known for its sense of peace amidst the waves, the Dargah draws visitors of all faiths seeking blessings and views of the open sea."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, South Mumbai, Maharashtra",
    "description": "At the northern end of Marine Drive, this busy beach is a hub for Ganesh Visarjan celebrations every year. Known for its lively street‑food scene—pani puri, kulfi, corn—it’s a place to soak in Mumbai's festive spirit and beach culture."
  },
  {
    "title": "Colaba Causeway & Kala Ghoda",
    "location": "Colaba & Fort, South Mumbai, Maharashtra",
    "description": "A vibrant cultural corridor known for its bohemian charm—flea markets, street art, galleries, colonial facades, chic cafés, and heritage museums. Strolling here offers tastes of fashion, art, history, and street-life all in one eclectic walk."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "A verdant break from city bustle, this rare urban jungle spans over 100 km² and houses wildlife like leopards, deer, and monkeys. Within it lies the ancient Kanheri Caves—Buddhist-carved sanctuaries and temples set among forest trails and streams."
  }
],



  "services": [
    {
      "name": "Nashik to Mumbai Cab",
      "description": "Travel comfortably from Nashik to Mumbai with Deva Cabs’ dependable intercity cab services. Whether it's a business visit, family outing, or airport transfer, we offer a wide range of vehicles—sedans, SUVs, and premium options—tailored to your needs. Enjoy a smooth ride with verified chauffeurs, well-maintained vehicles, and GPS-enabled tracking. We ensure on-time pickups, transparent pricing, and complete peace of mind on this scenic highway route."
    },
    {
      "name": "One-way cab Nashik to Mumbai",
      "description": "Deva Cabs offers convenient and cost-effective one-way taxi services from Nashik to Mumbai. Skip the hassle of return charges and pay only for the distance you travel. Our one-way service is ideal for business trips, medical visits, and leisure travelers. Choose from AC sedans or spacious SUVs and enjoy a relaxed ride with our courteous drivers."
    },
    {
      "name": "Round trip taxi Nashik to Mumbai",
      "description": "Planning a round trip from Nashik to Mumbai? Book Deva Cabs for a comfortable return journey with included wait time. Ideal for day trips, events, and personal appointments, our round trip packages offer flexibility, comfort, and value for money. Select from multiple vehicle categories and enjoy uninterrupted travel with our experienced chauffeurs."
    },
    {
      "name": "AC cab hire Nashik to Mumbai",
      "description": "Beat the heat and humidity with our fully air-conditioned cab options for the Nashik to Mumbai route. Deva Cabs ensures a cool and refreshing ride with clean interiors, plush seating, and reliable AC performance. Choose from budget sedans to luxury vehicles, all equipped for your comfort."
    },
    {
      "name": "SUV cab Nashik to Mumbai",
      "description": "Need more space and comfort for your journey? Hire an SUV cab from Nashik to Mumbai with Deva Cabs. Our SUVs offer generous legroom, luggage capacity, and a smooth ride—perfect for family trips, group outings, or carrying extra luggage. Travel worry-free with GPS navigation and experienced drivers."
    },
    {
      "name": "Chauffeur-driven cab Nashik to Mumbai",
      "description": "Sit back and relax with our chauffeur-driven cab service from Nashik to Mumbai. Our professional drivers are punctual, polite, and experienced in intercity travel. Whether you're traveling solo or with family, enjoy a safe and smooth journey backed by Deva Cabs’ commitment to quality service and customer satisfaction."
    },
    {
      "name": "Affordable Nashik to Mumbai cab",
      "description": "Looking for a budget-friendly ride from Nashik to Mumbai? Deva Cabs offers affordable taxi services without compromising on safety or quality. Get transparent, all-inclusive pricing and a variety of vehicle options to match your travel needs. Perfect for everyday commuters, students, or group travelers."
    },
    {
      "name": "Online booking Nashik to Mumbai cab",
      "description": "Book your Nashik to Mumbai cab online in minutes with Deva Cabs. Our seamless online platform lets you choose your car, set pickup time, and confirm your ride instantly. With secure payment options and instant confirmation, you get a hassle-free booking experience backed by dependable service."
    }
  ],
  "tableData": [
    ["Nashik to Mumbai Cab", "-One-way cab Nashik to Mumbai"],
    ["Round trip taxi Nashik to Mumbai", "-AC cab hire Nashik to Mumbai"],
    ["SUV cab Nashik to Mumbai", "-Chauffeur-driven cab Nashik to Mumbai"],
    ["Affordable Nashik to Mumbai cab", "-Online booking Nashik to Mumbai cab"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Nashik to Mumbai Cab Service",
    "WhyChoosedescription": "Travel conveniently from Nashik to Mumbai with our trusted cab service. Whether you’re heading for business meetings, family visits, or leisure trips, our well-maintained vehicles and experienced drivers ensure a comfortable and punctual journey along this popular 170 km route."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for All Group Sizes",
    "WhyChoosedescription": "Our fleet includes air-conditioned sedans, SUVs, and tempo travellers to accommodate solo travelers, families, and larger groups. Each vehicle is equipped with comfortable seating, ample legroom, and sufficient luggage space to make your long-distance travel relaxing and hassle-free."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with the Nashik–Mumbai highway, familiar with traffic patterns, shortcuts, and key stops en route. They prioritize safety and punctuality, ensuring a smooth and stress-free journey."
  },
  {
    "WhyChooseheading": "Flexible Packages Tailored to Your Needs",
    "WhyChoosedescription": "Choose from one-way, round trip, or hourly rental packages based on your travel plans. Whether you need a simple transfer or a day-long trip with multiple stops, we provide customizable options to suit your schedule and budget."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Our pricing is upfront and all-inclusive, covering tolls, fuel, parking, and driver allowance. There are no hidden charges, allowing you to plan your travel expenses confidently and enjoy value-for-money service."
  },
  {
    "WhyChooseheading": "24/7 Cab Availability for Your Convenience",
    "WhyChoosedescription": "We operate around the clock to cater to your travel needs. Whether you have an early morning departure or a late-night arrival, our Nashik to Mumbai cabs are available at any hour to provide seamless transportation."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your cab effortlessly online or through our customer support. Get instant confirmation with all necessary trip and driver details, ensuring a hassle-free and organized travel experience."
  },
  {
    "WhyChooseheading": "Safe, Sanitized, and GPS-Enabled Vehicles",
    "WhyChoosedescription": "Our vehicles are regularly sanitized and maintained to the highest standards. Equipped with GPS tracking, seat belts, and emergency kits, we prioritize your safety and comfort throughout your journey from Nashik to Mumbai."
  }
]














    }




const faqData = [
  {
    question: "Can I book a cab from Nashik to Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers dependable and comfortable cab services from Nashik to Mumbai for both personal and business travel."
  },
  {
    question: "How long does it take to travel from Nashik to Mumbai by cab?",
    answer: "The journey typically takes around 3.5 to 5 hours, depending on traffic and road conditions."
  },
  {
    question: "What types of vehicles are available for the Nashik to Mumbai route?",
    answer: "We offer a variety of vehicles such as sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your group size and budget."
  },
  {
    question: "Is one-way cab booking available from Nashik to Mumbai?",
    answer: "Yes, Deva Cabs provides both one-way and round-trip cab services between Nashik and Mumbai."
  },
  {
    question: "Are tolls and driver allowances included in the fare?",
    answer: "Toll charges, parking, and driver allowance are typically extra and will be clearly explained at the time of booking."
  },
  {
    question: "Can I book a Nashik to Mumbai cab service at any time?",
    answer: "Yes, our cab service operates 24/7, so you can book your ride anytime that fits your schedule."
  },
  {
    question: "Is the trip safe and suitable for senior citizens or children?",
    answer: "Absolutely. Our vehicles are clean, air-conditioned, and our professional drivers ensure a safe and comfortable journey for all passengers."
  },
  {
    question: "Can I request a stop at Trimbakeshwar or other points along the way?",
    answer: "Yes, you can customize your trip with planned halts like Trimbakeshwar. Just inform us at the time of booking."
  },
  {
    question: "Is this cab service suitable for airport transfers to Mumbai?",
    answer: "Yes, we provide reliable Nashik to Mumbai Airport transfers with punctual service and professional drivers."
  },
  {
    question: "Why choose Deva Cabs for Nashik to Mumbai cab service?",
    answer: "Deva Cabs ensures timely pickup, clean vehicles, experienced drivers, and transparent pricing for a stress-free ride."
  }
];

const testimonialData = [
  {
    id: 85,
    name: 'Mr. Abhijeet Patil',
    role: 'Corporate Client',
    review: 'I frequently travel from Nashik to Mumbai and Deva Cabs has been consistently reliable. Clean cars and on-time service.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 86,
    name: 'Mrs. Lata Mahajan',
    role: 'Senior Citizen',
    review: 'We booked a cab from Nashik to Mumbai for a hospital visit. The driver was courteous and very helpful. Thank you, Deva Cabs!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Nashik to Mumbai Cab",
  "image": "https://devacab.com/assets/images/nashik-to-mumbai-cab.jpg", // Replace with actual image URL
  "description": "Book affordable Nashik to Mumbai cab with chauffeur-driven SUVs and AC cabs. Available for one-way and round trip taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/nashik-to-mumbai-cab" // Update with actual URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Nashik to Mumbai Cab | Book Taxi from Nashik to Mumbai | Deva Cabs</title>
  <meta
    name="description"
    content="Affordable Nashik to Mumbai cab service with chauffeur-driven SUVs and AC cabs. Book your one-way or round trip taxi online today."
  />
  <meta
    name="keywords"
    content="Nashik to Mumbai Cab, One-way cab Nashik to Mumbai, Round trip taxi Nashik to Mumbai, AC cab hire Nashik to Mumbai, SUV cab Nashik to Mumbai, Chauffeur-driven cab Nashik to Mumbai, Affordable Nashik to Mumbai cab, Online booking Nashik to Mumbai cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Nashiktomumbaicab;